import React, { useRef } from 'react'
import { Link } from 'react-router-dom'
import {
  Button,
  Icon,
  Popup,
  Segment,
  List,
  StreamlineIcon,
  carbon,
} from '@waylay/react-components'
import DangerListItem from '~/components/Common/DangerListItem'
import { Menu } from '@streamlinehq/streamline-bold/lib/interface-essential'

interface ReusablePopupProps {
  name: string
  taskCount?: number
  discoveryTemplate: boolean
  handleDownload?: () => void
  showRemoveModal: () => void
  reload: any
  isIcon?: boolean
  onPromote: any
  onDemote: any
}

const ReusablePopup = ({
  name,
  taskCount,
  discoveryTemplate,
  handleDownload,
  onPromote,
  onDemote,
  showRemoveModal,
  reload,
  isIcon,
}: ReusablePopupProps) => {
  const popupRef = useRef(null)

  const handlePromote = () => {
    onPromote()
    popupRef.current?.hide()
  }

  const handleDemote = () => {
    onDemote()
    popupRef.current?.hide()
  }

  return (
    <Popup
      onCreate={instance => {
        popupRef.current = instance
      }}
      placement="bottom-end"
      appendTo={() => document.body}
      content={
        <List as={Segment} padding={0} interactive>
          <List.Item
            as={Link}
            to={`/tasks?query=${`template:"${name}"&sort=creationtime:descending`}`}
          >
            View {taskCount} tasks
          </List.Item>
          <List.Item onClick={() => reload.mutate()}>Reload tasks</List.Item>
          <List.Item onClick={handleDownload}>Download</List.Item>
          {discoveryTemplate ? (
            <List.Item onClick={handleDemote}>
              Unlink discovery template
            </List.Item>
          ) : (
            <List.Item onClick={handlePromote}>
              Make discovery template
            </List.Item>
          )}
          <List.Divider />
          <DangerListItem onClick={showRemoveModal}>
            <Icon name="delete_outline" /> Delete
          </DangerListItem>
        </List>
      }
    >
      {isIcon ? (
        <Button
          kind="secondary"
          outline
          style={{
            width: '20px',
            height: '20px',
            backgroundColor: 'transparent',
            border: 'none',
          }}
        >
          <Icon
            name="more_horiz"
            style={{
              fontSize: '20px',
              color: `${carbon}`,
              justifySelf: 'flex-end',
            }}
          />
        </Button>
      ) : (
        <Button kind="secondary" outline>
          <StreamlineIcon iconData={Menu.NavigationMenuHorizontal1Alternate} />
          More actions
        </Button>
      )}
    </Popup>
  )
}

export default ReusablePopup
